import classNames from 'classnames';
import { Droppable } from 'react-beautiful-dnd';

const Drop = ({
  id,
  type = 'DEFAULT',
  isDropDisabled = false,
  ...props
}) => {
  return (
    <Droppable
      key={id}
      droppableId={id}
      type={type}
      isDropDisabled={isDropDisabled}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            {...props}
            className={classNames(`${props?.className}`, {
              'bg-npl-yellow-light-solid-2': snapshot.isDraggingOver
            })}>
            {props.children}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};

export default Drop;
